
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2e1e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2e1e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("hqokU", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $caf7be09e81127c6$export$6503ec6e8aabbaf; }, function (v) { return $caf7be09e81127c6$export$6503ec6e8aabbaf = v; });
var $caf7be09e81127c6$export$6503ec6e8aabbaf;
var $caf7be09e81127c6$export$f7ad0328861e2f03;
"use strict";
var $caf7be09e81127c6$var$mapping = new Map();
function $caf7be09e81127c6$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$caf7be09e81127c6$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $caf7be09e81127c6$var$resolve(id) {
    var resolved = $caf7be09e81127c6$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$caf7be09e81127c6$export$6503ec6e8aabbaf = $caf7be09e81127c6$var$register;
$caf7be09e81127c6$export$f7ad0328861e2f03 = $caf7be09e81127c6$var$resolve;

});

var $ff96e2c9427ae755$exports = {};

(parcelRequire("hqokU")).register(new URL("", import.meta.url).toString(), JSON.parse('["kFsp7","index.83638fc8.js","aBng5","service-worker.js","kDbut","icon512-gray.be383917.png","8zMgV","share.f4d2de34.svg","aMr6x","house.4786c191.svg","9i60B","discord.0f995d10.png"]'));


//# sourceMappingURL=index.runtime.dfa82248.js.map
